<style lang="scss" scoped>
.similar-design-container {
  width: 750px;
  height: 190px;
  margin: 48px auto 0;
  position: relative;
  // overflow: hidden;
  margin-bottom: 15px;
  overflow-x: scroll;
  .design-content {
    // width: 702px;
    // overflow: hidden;
    display: flex;
    position: absolute;
    align-items: center;
    // height: 200px;
    // overflow: scroll;

    .guide-container {
      width: 100px;
      height: 170px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .desp {
        width: 60px;
        writing-mode: vertical-lr;
        // letter-spacing: 5px;
        // padding-top: 3px;
        // white-space: 
        display: flex;
        justify-content: center;
        align-items: center;
        // font-size: 12px;
      }
      .skc-num {
        // writing-mode: lr;
        width: 60px;
        text-align: center;
      }

      .swipe-icon {
        margin: 0 auto;
        width: 40px;
        height: 11px;
      }
      .item {
        font-size: 26px;
        color: #999;
      }
    }

    .skc-item {
      flex:0 0 auto;
      width: 170px;
      margin-right: 16px;
      .img-container {
        height: 170px;
        width: 170px;
        display: block;
        border: 2px solid #eeeeee;
        overflow: hidden;
        overflow: hidden;
        .img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }

      .msg {
        text-align: center;
        padding: 8px 0 26px;
      }
    }
    .loading {
      // line-height: 258px;
      text-align: center;
      height: 250px;
      width: 50px;
      font-size: 24px;
      letter-spacing: 3px;
      writing-mode: vertical-lr;
    }
    .load-more {
      // line-height: 258px;
      text-align: center;
      height: 180px;
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // position: absolute;
      // right: -100px;
      .item {
        font-size: 24px;
        height: 26px;
      }
    }
  }
}
</style>

<template>
<div>
  <div class="similar-design-container">
    <div class="design-content">
      <div class="guide-container">
        <!-- <div class="desp"> -->
          <div class="item">相</div>
          <div class="item">似</div>
          <div class="item">款</div>
          <div class="item">式</div>
          <div class="item">（{{totalSimilar}}）</div>
        <!-- </div> -->
        <!-- 删掉icon -->
        <!-- <div class="swipe-icon">
          <img src='./../../../assets/images/ai-picture//left-swipe.png'>
        </div> -->
      </div>
      <div class="skc-item" v-for="(similar, index) in similarList" :key="index" @click="goDetail(similar)">
        <div class="img-container">
          <img class="img" v-lazy="similar.mainPic">
        </div>
        <!-- <div class="msg" v-if="similar.saleCount > 0">
          在售<span style="color: red">{{similar.saleCount}}</span>件
        </div> -->
      </div>
      <div class="loading" v-if="loading">
        加载中
      </div>
      <div class="load-more" v-if="totalSimilar > 20" @click="goSimilar()">
        <div class="item">点</div>
        <div class="item">击</div>
        <div class="item">查</div>
        <div class="item">看</div>
        <div class="item">更</div>
        <div class="item">多</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  props: {
    similarList: {
      default: () => {
        return []
      }
    },
    totalSimilar: {
      default: () => {
        return 0
      }
    },
    skcInfo: {
      default: () => {
        return {}
      }
    },
    skcList: {
      default: () => {
        return []
      }
    },
  },
  data () {
    return {
      myScroll: null,
      maxX: 0,
      loading: false,
    }
  },
  watch: {
    similarList: function (val) {
      if (this.myScroll) {
        setTimeout(() => this.myScroll.refresh());
      }
    }
  },
  methods: {
    goSimilar () {
      this.$router.push({ path: `ai-picture/similar-design?skcInfo=${JSON.stringify(this.skcInfo)}&skcList=${JSON.stringify(this.skcList)}` })
    },
    goDetail (similar) {
      const { skc, kindId, brandId } = similar;
      console.log(skc, kindId, brandId);
      this.$router.push({ path: `ai-picture?type=1&params=${JSON.stringify({ skc, kindId, brandId })}` })
    }
  },
  mounted () {
    // const touchElement = {};
    // const container = document.getElementsByClassName('.similar-design-container')[0]
    // container.addEventListener('touchstart', function(e) {
    //   touchElement.startX = e.touches[0].clientX;
    //   touchElement.startY = e.touches[0].clientY;
    // });
    // container.addEventListener('touchmove', function(e) {
    //     const deltaX = e.touches[0].clientX - touchElement.startX;
    //     const deltaY = e.touches[0].clientY - touchElement.startY;
    //     if (Math.abs(Math.asin(deltaY/deltaX)) <= 15/180*Math.PI && e.cancelable) {
    //       e.preventDefault();
    //     }
    // })
  },
  updated () {}
}
</script>
